// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qc-settings-app-width {
    width: 450px;
}

.qc-settings-app-heading {
    text-align: center;
    margin: 5px;
}

.qc-settings-app-input-field {
    width: 110px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/qc_settings_app.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".qc-settings-app-width {\n    width: 450px;\n}\n\n.qc-settings-app-heading {\n    text-align: center;\n    margin: 5px;\n}\n\n.qc-settings-app-input-field {\n    width: 110px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
